import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {Grid, Typography} from '@mui/material';
import {SellingPoints} from './SellingPoints';
import {CommonFields} from '../CommonFields';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const Introduction = () => {
  const [fileLoading, setFileLoading] = useState(false);

  const {
    watch,
    setValue,
    formState: {errors},
  } = useFormContext();

  const values = watch('menus.navigations.introduction') || {};

  return (
    <Grid container>
      <CommonFields name={'menus.navigations.introduction'} />

      <Grid item xs={12}>
        <Typography variant='h6' mb={2}>
          Selling Points
        </Typography>
        <SellingPoints
          name={`menus.navigations.introduction.sellingPoints`}
          values={values?.sellingPoints}
          errors={errors?.menus?.navigations?.introduction?.sellingPoints}
        />
      </Grid>

      <Grid item md={6} mt={2}>
        <Typography variant='h6' mb={2}>
          Image
        </Typography>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 650, height: 600}}}
          label={'Introduction Image'}
          name={'menus.navigations.introduction.image'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.introduction.image`, links[0])
          }
          destination={'landing-pages'}
          values={values?.image}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>
    </Grid>
  );
};
